import { render, staticRenderFns } from "./WebSessionShell.vue?vue&type=template&id=2b22bce8&scoped=true"
import script from "./WebSessionShell.vue?vue&type=script&lang=js"
export * from "./WebSessionShell.vue?vue&type=script&lang=js"
import style0 from "./WebSessionShell.vue?vue&type=style&index=0&id=2b22bce8&prod&scoped=true&lang=css"
import style1 from "./WebSessionShell.vue?vue&type=style&index=1&id=2b22bce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22bce8",
  null
  
)

export default component.exports